import { Poly } from './poly';
import { createShape } from './util';
export const Polygon = createShape('polygon', {}, { parent: Poly });
//# sourceMappingURL=polygon.js.map